import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, concatMap, map, of } from "rxjs";
import { NotificationService } from "@core/services";
import { search, searchFailure, searchSuccess } from "@users/store/actions/user-search.actions";
import { UserSearchService } from "@users/services/user-search/user-search.service";

@Injectable()
export class UserSearchEffects {
  search$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(search),
      concatMap(({ searchTerm: mail }) =>
        this.userSearchService.searchUser(mail).pipe(
          map((users) => searchSuccess({ users: users })),
          catchError(() => of(searchFailure()))
        )
      )
    );
  });

  searchFailure$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(searchFailure),
        map(() =>
          this.notificationService.showTranslatedNotification(
            "notifications.userSearch_search_failure",
            "warning"
          )
        )
      );
    },
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private notificationService: NotificationService,
    private userSearchService: UserSearchService
  ) {}
}
